<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div v-if="!isLoading && hasNotification">
    <div class="max-w-7xl mx-auto mb-5 py-3 px-3 rounded-lg" v-bind:class="'bg-' + notificationColor + '-600'">
      <div class="flex items-center justify-between flex-wrap">
        <div class="w-0 flex-1 flex items-center">
          <span v-bind:class="'bg-' + notificationColor + '-800'" class="flex p-2 rounded-lg">
            <CheckIcon class="h-6 w-6 text-white" aria-hidden="true" v-if="notificationIcon == 'success'" />
            <SpeakerphoneIcon class="h-6 w-6 text-white" aria-hidden="true" v-else-if="notificationIcon == 'info'" />
            <ExclamationIcon class="h-6 w-6 text-white" aria-hidden="true" v-else />
          </span>
          <p class="ml-3 font-medium text-white truncate">
            <span>
                {{ notification.message }}
            </span>
          </p>
        </div>
        <div class="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto" v-if="notification.link">
          <a v-bind:href="notification.link" v-bind:class="'text-' + notificationColor + '-600 hover:bg-' + notificationColor + '-50'" class="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium bg-white">
            {{ notification.link_text }}
          </a>
        </div>
        <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
          <button type="button" v-bind:class="'hover:bg-' + notificationColor + '-500'" class="-mr-1 flex p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2" v-on:click="hideNotification">
            <span class="sr-only">Dismiss</span>
            <XIcon class="h-6 w-6 text-white" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckIcon, SpeakerphoneIcon, ExclamationIcon, XIcon } from '@heroicons/vue/outline'

export default {
  components: {
    CheckIcon,
    SpeakerphoneIcon,
    ExclamationIcon,
    XIcon,
  },
  props: {
      endpoint: {
          type: String,
          required: true
      }
  },
  data: function () {
      return {
          notification: null,
          notificationType: null,
          notificationColor: 'green',
          notificationIcon: 'success',
          hasNotification: false,
          isLoading: true
      }
  },
  methods: {
      async getData() {
          const self = this;

          window.axios.get(self.endpoint)
              .then(response => {
                  self.notification = response.data;
                  self.hasNotification = Object.keys(response.data).length != 0;
                  self.isLoading = false;

                  self.getNotificationType();
              })
              .catch(error => {
                  console.log(error);
              });
      },
      getNotificationType: function () {

          var self = this;

          if (!self.hasNotification) {
              return;
          }

          self.notificationIcon = self.notification['type'];

          switch(self.notification['type']) {
              case 'danger':
                self.notificationColor = 'rose';
                break;
              case 'info':
                self.notificationColor = 'cyan';
                break;
              default:
                self.notificationColor = 'green';
          }

      },
      hideNotification: function () {
          this.hasNotification = false;
      }
  },
  mounted() {
      this.getData();
  }
}
</script>
